/* eslint-disable no-console */
// @ts-ignore
import upperFirst from 'lodash/upperFirst'
// @ts-ignore
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import { endpoints } from '../endpoints'
import DefaultRepository from './DefaultRepository'
import { searchSubStringInArray } from '~/utils/helpers'

// @ts-ignore
const classesData = require.context('./repositories/', false, /^\.\/[A-Za-z]+(Repository)\.ts$/)
const endpointHasClass = searchSubStringInArray(classesData.keys())
export interface Repositories {
  [key: string]: any
}

export const RepositoriesFactory = (axios: NuxtAxiosInstance) =>
  Object.keys(endpoints).reduce<Repositories>((acc, name) => {
    const key = endpointHasClass(`${upperFirst(name)}Repository`)
    const Repository = key ? classesData(key).default : DefaultRepository
    acc[name] = new Repository(endpoints[name], axios)

    return acc
  }, {})
